module.exports = __webpack_public_path__ + "img/atv-track--icon--gray.de534af1.svg";